export default {
	apiKey: "AIzaSyBGMFeUT4Pj7jNlqpyynjm6HL-g1KLVsbw",
	authDomain: "ayun-quantity-uat.firebaseapp.com",
	projectId: "ayun-quantity-uat",
	storageBucket: "ayun-quantity-uat.appspot.com",
	messagingSenderId: "575033995230",
	appId: "1:575033995230:web:adaf8adfa8f467e2b6f74f",
	measurementId: "G-3VFRVGBVKF"
};